import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { deleteCampaign } from "../../../services/notification";

const CampaignCancelModal = ({ isOpen, onClose, campaign, onCancelled }) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!campaign?._id || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      const res = await deleteCampaign(campaign._id);
      if (res.status === 200) {
        onCancelled?.();
        onClose();
      }
    } catch (error) {
      console.error("Error cancelling campaign:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      contentClassName="rounded-lg char-modal-content campaign-cancel-modal"
      style={{ maxWidth: "600px", width: "600px" }}
    >
      <ModalHeader className="char-modal-header">
        <span className="char-modal-header-title">
          {t("campaign.cancelCampaign")}
        </span>
        <button
          type="button"
          onClick={onClose}
          className="char-modal-header-close"
          aria-label={t("Close")}
        >
          <i className="fas fa-times char-modal-header-close-icon" />
        </button>
      </ModalHeader>
      <ModalBody className="campaign-cancel-modal__body">
        <p className="campaign-cancel-modal__intro">
          {t("campaign.cancelModalQuestion")}
        </p>
        <p className="campaign-cancel-modal__intro">
          {t("campaign.cancelModalWarning")}
        </p>
        <ul className="campaign-cancel-modal__list">
          <li>{t("campaign.cancelModalBullet1")}</li>
          <li>{t("campaign.cancelModalBullet2")}</li>
          <li>{t("campaign.cancelModalBullet3")}</li>
        </ul>
      </ModalBody>
      <ModalFooter className="char-modal-footer campaign-cancel-modal__footer">
        <button
          type="button"
          className="modal-button modal-button-cancel"
          onClick={onClose}
          disabled={isSubmitting}
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          className={`modal-button modal-button-save ${isSubmitting ? "disabled" : ""}`}
          onClick={handleConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? t("Saving...") : t("campaign.cancelCampaign")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CampaignCancelModal;
